import {Routes} from '@angular/router';
import {AdvGenerateComponent} from './adv/adv-generate.component';
import {advGenerateResolver} from './adv/adv-generate.resolver';
import {customerRoutes} from './customer.route';
import {ErrorFallbackComponent} from './error-fallback/error-fallback.component';
import {loggedInGuard} from './permissions/logged-in.guard';
import {createFeatureAccessGuard} from './permissions/module-access.guard';
import {createAccessRightGuard} from './permissions/user/user-accessright.guard';
import {monitoredJobsResolver} from './service/jobmanager/monitoring/job-monitoring.resolver';
import {userResolver} from './shared/resolver/user.resolver';
import {socialMediaAccessGuard} from './social-media/social-media-access.guard';
import {StrutsComponent} from './struts/struts.component';
import {strutsGuard} from './struts/struts.guard';

export const routes: Routes = [
	...customerRoutes,
	{
		path: '',
		redirectTo: '/start.do',
		pathMatch: 'full',
	},
	{
		path: 'ssologin.do',
		redirectTo: '/angularlogin.do',
		pathMatch: 'full',
	},
	{
		path: 'login.do',
		redirectTo: '/angularlogin.do',
		pathMatch: 'full',
	},
	{ path: 'error', redirectTo: '/strutsreturn.do?forwardTo=error-default-message' },
	{ path: 'error-fallback', component: ErrorFallbackComponent },
	{
		path: 'marketingplaner',
		loadChildren: () => import('./marketingplaner/marketingplaner.routes').then(m => m.MARKETINGPLANER_ROUTES),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'beverage-verwaltung',
		loadChildren: () => import('./beverage-verwaltung/beverage-verwaltung.module').then(m => m.BeverageVerwaltungModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'configuration',
		loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'preferences',
		loadChildren: () => import('./preferences/preferences.module').then(m => m.PreferencesModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'social-media',
		loadChildren: () => import('./social-media/social-media.routes').then(m => m.routes),
		canActivate: [
			loggedInGuard,
			socialMediaAccessGuard,
		],
	},
	{
		path: 'kpi-dashboard',
		loadChildren: () => import('./kpi-dashboard/kpi-dashboard.routes').then(m => m.routes),
		canActivate: [
			loggedInGuard,
			createFeatureAccessGuard('showKpiDashboard'),
		],
	},
	{
		path: 'plakat-favoriten',
		loadChildren: () => import('./plakat-favoriten/plakat-favoriten.module').then(m => m.PlakatFavoritenModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'service/job',
		loadChildren: () => import('./service/job/service-job.module').then(m => m.ServiceJobModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'unique-id-vergleich',
		loadChildren: () => import('./service/unique-id-vergleich/unique-id-vergleich.routes').then(m => m.routes),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'sepa-transport-jobs-administration',
		loadChildren: () => import('./service/sepa-transport-jobs-administration/sepa-transport-jobs-administration.module').then(m => m.SepaTransportJobsAdministrationModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'image-compare',
		loadChildren: () => import('./service/image-compare/image-compare.module').then(m => m.ImageCompareModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'edit-homepage/:id',
		loadChildren: () => import('./service/edit-homepage/edit-homepage.module').then(m => m.EditHomepageModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'importhistory',
		loadChildren: () => import('./service/importhistory/importhistory.module').then(m => m.ImporthistoryModule),
		canActivate: [
			loggedInGuard,
		],
	},

	{
		path: 'startseiten-slider',
		loadChildren: () => import('./startseiten-slider/startseiten-slider.module').then(m => m.StartseitenSliderModule),
		canActivate: [
			loggedInGuard,
			createFeatureAccessGuard('sliderPictureUpload'),
		],
	},
	{
		path: 'auth/protocol/openid-connect',
		loadChildren: () => import('./sso-provider/sso-provider.module').then(m => m.SsoProviderModule),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'adv/generate',
		component: AdvGenerateComponent,
		canActivate: [
			loggedInGuard,
		],
		resolve: { advData: advGenerateResolver },
	},
	{
		path: 'einpflegeFeedback',
		loadChildren: () => import('./einpflege-feedback/einpflege-feedback.routes').then(m => m.EINPFLEGEFEEDBACK_ROUTES),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'briefingTool',
		loadChildren: () => import('./briefing-tool/briefing-tool.routes').then(m => m.BRIEFINGTOOL_ROUTES),
		canActivate: [
			loggedInGuard,
		],
	},
	{
		path: 'service/jobmanager/monitoring',
		loadComponent: () => import('./service/jobmanager/monitoring/job-monitoring.component').then(m => m.JobMonitoringComponent),
		runGuardsAndResolvers: 'always',
		canActivate: [
			loggedInGuard,
			createAccessRightGuard('monitorJobManager'),
		],
		resolve: {
			monitoredJobs: monitoredJobsResolver,
		},
	},
	{
		path: 'selectzwischenseite',
		loadComponent: () => import('./selectzwischenseite/selectzwischenseite.component').then(m => m.SelectZwischenseiteComponent),
		canActivate: [
			loggedInGuard,
		],
		resolve: {
			user: userResolver,
		},
	},
	{
		path: '**',
		component: StrutsComponent,
		canActivate: [strutsGuard],
	},
];
